export default {
  en: {
    title: "",
  },
  pl: {
    forWho: {
      title: "Dla kogo jest Hack4change?",
      description: `
      <p><strong>Do uczestnictwa w hackathonie zapraszamy innowatorów, programistów, grafików, UX designerów, socjologów, psychologów, ekologów i wszystkich tych, którym bliska jest idea walki z kryzysem klimatycznym i innymi problemami naszej planety.</strong></p>
      <p>W trakcie hackathonu uczestnicy połączą siły, tworząc interdyscyplinarne zespoły, które wspólnie będą pracowały nad prototypami proekologicznych urządzeń i aplikacji.</p>
      <p>Do dyspozycji uczestników będzie również grono mentorów - ekspertów ze świata technologii, nauki i biznesu, którzy będą dzielić się swoimi doświadczeniami z uczestnikami. Razem podejmiemy walkę z największymi zagrożeniami współczesnego świata, szukając prostych rozwiązań skomplikowanych problemów.</p>
      <p>Efektem hackathonu będą prototypy innowacyjnych rozwiązań wspierających dobrostan człowieka, walkę z zanieczyszczeniem środowiska, ociepleniem klimatu, poprawą komfortu życia w lokalnych środowiskach. Myślmy globalnie - zacznijmy lokalnie!</p>
      `,
      image1: require("./images/forWhoImg1.png").default,
      image2: require("./images/forWhoImg2.png").default,
      splash: require("./images/imgSplash.svg").default,
    },
    aroundH4c: {
      title: "Wokół Hack4change",
      description: `
      <p>Jak co roku, dla naszych uczestników przygotujemy kilka dni <strong>warsztatów</strong> z różnych technologii (m.in AI, chmura, data science, języki programowania, testowanie oprogramowania, prezentacje projektów).</p>
      <p>Celem warsztatów jest <strong>wprowadzenie uczestników w tematykę ścieżek tegorocznego hackathonu.</strong> Warsztaty mają za zadanie uczyć<br/> i inspirować. </p>
      <p>Do współpracy zapraszamy specjalistów i praktyków z branży IT oraz otoczenia biznesu.</p>
      `,
      image1: require("./images/aroundH4c1.png").default,
      image2: require("./images/aroundH4c2.png").default,
      splash: require("./images/aroundH4cSplash.svg").default,
      ecofuture: require("./images/ecofuture.png").default
    },
    river: {
      title: "Sprzątanie rzeki!",
      description: `
      <p>W ramach Hack4change, chcemy
      zaproponować Wam wspólny spływ kajakowy po rzece, wraz ze
      sprzątaniem terenu wokół spływu.
      Odbędzie się <strong>19 kwietnia 2026</strong> na rzece Reda.
      </p>
      `,
      image1: require("./images/kajaki.png").default,
      image2: require("./images/aroundH4c2.png").default,
      button: "Weź udział &rarr;"
    },
    forest: {
      title: "Sadzenie drzew!",
      description: `
      <p>W ramach praktycznych działań, mających rzeczywiste przełożenie na otaczający nas świat, w tym roku zajmiemy się sadzeniem drzew.<br/><br/>
      Chcemy, żeby nasze działania nie kończyły się wraz z finałem hackathonu. Dlatego akcję sadzenia drzew zaplanowaliśmy na jesień, kiedy warunki do nasadzeń będą najbardziej optymalne.
      </p>
      `,
      image1: require("./images/trees.png").default,
      image2: require("./images/aroundH4c2.png").default,
      button: "Weź udział &rarr;"
    },
    cooperation: {
      title: "Współpraca sponsorska",
      description: `
      <p><strong>Do szczególnej współpracy przy organizacji Hack4change, zapraszamy firmy i instytucje, które chciałby aktywnie włączyć się i współtworzyć wydarzenie.</strong></p>
      <a href='#form'>
        Dowiedz się więcej &rarr;
      </a>
      `,
      image1: require("./images/cooperation1.png").default,
      image2: require("./images/cooperation2.png").default,
      splash: require("./images/imgSplash.svg").default,
    },
    animatonSumm: {
      title: "Animaton",
      description: `<p style="text-align: left;">
Piąta edycja Hack4Change zyskała nowy wymiar wizualny dzięki współpracy z Instytutem Kultury Miejskiej w Gdańsku!<br/><br/>
Animaton to wyjątkowa część wydarzenia, w której twórcy animacji, artyści i programiści łączyli siły, by opowiadać o ekologii w nowoczesnej, multimedialnej formie.<br/><br/>


Szukaliśmy projektów, które:<br/>
- poruszą temat zmian zachodzących w środowisku,<br/>
- pokażą pozytywne działania w obszarze ekologii podejmowane w Gdańsku,<br/>
- albo będą wizualnym wsparciem innych projektów powstających podczas Hack4Change – jako ich prezentacja, narracja lub forma promocji.<br/><br/>


W ramach Animatonu:<br/>
- tworzono animację o temacie “ekologia w mieście” (do 3 minut),<br/>
- łączono animację z muzyką i nowymi mediami,<br/>
- udowadniano, że ekologia może być tematem także w sztuce i kulturze.<br/>
</p>
`,
      image1: require("../Idea/images/animaton.jpg").default,
      image2: require("../Idea/images/cooperation2.png").default,
    },
    ecoFuture: {
      title: "EcoFuture",
      description: `<p style="text-align: left;">
EcoFuture to seria działań, które łączą praktyczną ochronę środowiska z edukacją i integracją naszej społeczności.<br/><br/>
Hack4Change to nie tylko technologia, ale także realny wpływ na otaczającą nas naturę. Dzięki wsparciu Fundacji InvestGDA oraz Balticon, realziując projekt EcoFuture rozszerzyliśmy Hack4Change o dodatkowe inicjatywy towarzyszące:<br/>
<ul>
<li><strong>Sprzątanie rzeki na kajakach</strong> - połączenie aktywnego wypoczynku z dbałością o lokalny ekosystem.</li>
<li><strong>Warsztaty przygotowawcze</strong> - zajęcia technologiczne, edukacyjne, z zakresu otwartych danych oraz ochrony środowiska.</li>
<li><strong>Ekologiczna wystawa</strong> - prezentacja zdjęć oraz śmieci zebranych podczas akcji kajakowej.</li>
<li><strong>Warsztaty dla młodzieży</strong> - edukacja w zakresie technologii i ekologii budująca świadomość u najmłodszych.</li>
<li><strong>Akcja sadzenia lasu</strong> - wspólne pozostawienie trwałego, zielonego śladu.</li>
</ul>
</p>
`,
      image1: require("../Idea/images/animaton.jpg").default,
      image2: require("../Idea/images/cooperation2.png").default,
    }

  },
}
